<template>
  <div id="app">
    <Nav v-if="showNav"></Nav>
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view />
  </div>
</template>

<script>
import Nav from './components/Nav/Nav.vue';

export default {
  components: {
    Nav,
  },
  created() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.setTouchDevice();
      const width = window.innerWidth;
      this.$store.dispatch('setCurrentWidth', width);
    },
    setTouchDevice() {
      const touchDevice =
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;
      this.$store.dispatch('setTouchDevice', touchDevice);
    },
  },
  computed: {
    showNav() {
      return this.isLoggedIn;
    },
  },
};
</script>
